// This file contains the javascript for the "watch video" banner/popup on the products.
// here are some search terms to find it later:
// .product-tag.yellow .video vimeo

import ActionButtons from "./Components/ProductSearch/ActionButtons.vue";
import debounce from "lodash/debounce";
import { store } from './store';  // Import the same Vuex store
import axios from "axios";
import {apiUrls, createSaveSearchParams} from "./data/OnLoginActionParams";
import {notificationController} from "./global/global_notifications";

class ProductsSearch {
  constructor() {
    if (typeof Vue !== "undefined" && $("#app").length > 0) {
      this.startApp();
    }

    // Active mobile filter tab
    this.active_mobile_filter = false;

    // Move between the nav and filter
    $(".back-to-nav").on("click", (e) => this.backToNav(e));
    $(".back-to-filter").on("click", (e) => this.openFilter(e));
    $(".open-search-filter").on("click", (e) => this.openFilter(e));

    // Show mobile filters
    $(".department-filter-trigger").on("click", () => this.showFilter("department"));
    $(".filter-filter-trigger").on("click", (e) => this.showFilter("filter"));
    $(".sortby-filter-trigger").on("click", (e) => this.showFilter("sort"));

    //new menu
    $(".department-trigger").on("click", (e) => this.showDepartments());
    $(".filter-trigger").on("click", (e) => this.showNewFilter());

    function resizeItems() {
      if (window.outerWidth <= 799) {
        $(".products-sortby").show();
        $(".products-category-nav").show();
        // $(".products-filters").show();

        $(".products-search").removeClass("open");

        // Moves filters back and forth between mobile and desktop
        // document
        //   .getElementById("products-filters-mobile")
        //   .appendChild(document.getElementById("gen-products-filters"));
      } else {
        // document
        //   .getElementById("products-filters-desktop")
        //   .appendChild(document.getElementById("gen-products-filters"));
      }
    }

    resizeItems();
    $(window).resize(() => resizeItems());
  }

  /**
   * Start VueJS app
   */
  startApp() {
    let classSelf = this;
    this.app = new Vue({
      el: "#app",
      store,
      components: {
        ActionButtons,
      },
      data() {
        let searchClient = window.algoliasearch(
          window.algoliaKeys.id,
          window.algoliaKeys.key
        );

        // Starter index
        let indexName;

        if (window.productType === "new") {
          indexName = "new_products";
        } else {
          indexName = "used_products_modified_desc";
        }

        indexName = window.addEnvPrefToIndex(indexName);

        return {
          industry: "all", //window.industryQuery,
          refineIndustry: null,
          refineNewCategory: null,
          searchClient,
          productType: window.productType,
          promoLabel: window.promoLabel,
          search: window.instantsearch({
            indexName,
            searchClient,
            routing: true,
          }),
          filters: {
            year: null,
            hours: null,
          },
          showAdvancedFilters : false,
          newCategory: null,
          newCategoryUrl: null,
          categoryFilter: [],
          categorySelect: [],
          globalRefine: null,
          openSelector: false,
          isAdvancedFilterOptions: false,
          isTech: false,
          locationName: '',
          isAdvancedFilterLocation: false,
          isAdvancedFilterBrand: false,
          isSale: false,
          promo: window.promo,
          clearance: window.clearance,
          hits: [],
          nbHits: 0,
          filtersOnly: true,
          user: window.user,
          loading: true,
          advancedNewOpen: false,
          isMainPage: false,
          viewType: "grid-view",
          quoteRequest: [],
          $newCategories: window.$newCategories,
          baseAssetUrl: window.baseAssetUrl,
        };
      },

      created() {
        this.detectedPage();
        setTimeout(() => {
          let captcha = document.querySelectorAll("div[class=g-recaptcha]");
          captcha.forEach(function (el) {
            grecaptcha.render(el);
          });
        }, 1000);
      },
      mounted() {
        // Default url?query= param to search for
        const _this = this;

        let $window = $(window);

        $window.on("load", () => {
          _this.createData();
          this.initIndustry();
          this.initClass();
        });

        // window.onpageshow = function (event) {
        //   if (event.persisted) {
        //     console.log("reloaded page");
        //     window.location.reload();
        //   }
        // };

        // document.addEventListener('visibilitychange', () => {
        //     if(document.visibilityState === 'hidden'){
        //         console.log('Items: ' + document.title, document.location.href);
        //         window.history.replaceState({ scrollTop: $window.scrollTop() }, document.title, document.location.href);
        //     }
        // });

        // Scroll to top of page when a dropdown is changed
        $(document).on("change", ".products-filters select", function () {
          window.scrollTo(0, 0);
        });

        // Default to list view on mobile
        window.addEventListener("resize", this.onResize);
      },

      computed: {
        isAdvancedFilter() {
          return this.isAdvancedFilterOptions || this.isAdvancedFilterLocation || this.isAdvancedFilterBrand
        },
        searchFilters() {
          let filters = "";

          if (this.promo) {
            filters += "promos.id:" + this.promo.id;
          }

          if (this.clearance) {
            filters += "is_clearance:true";
          }

          return filters;
        },
      },
      methods: {
        detectedPage(name) {
          let regexp = window.location.href.toString().match(/menu%5Bcategory%5D=(?<category>[^&]*)/);

          this.isMainPage = !(name || (regexp && regexp.groups.category));
        },
        download(content, fileName, contentType) {
          const a = document.createElement("a");
          const file = new Blob([JSON.stringify(content)], {type: contentType});
          a.href = URL.createObjectURL(file);
          a.download = fileName;
          a.click();
        },
        initIndustry() {
          let regexp = window.location.href.toString().match(/menu%5Bindustry%5D=(?<industry>[^&]*)/);

          if (regexp && regexp.groups.industry) {
            const el = document.getElementById(`${decodeURIComponent(regexp.groups.industry)}`);
            this.industry = decodeURIComponent(regexp.groups.industry);

            if (el) {
              el.classList.remove('!text-black');
              el.classList.add('!text-footer-title');
            }
          }
        },
        initClass() {
          let regexp = window.location.href.toString().match(/menu%5Bcategory%5D=(?<category>[^&]*)/);

          if (regexp && regexp.groups.category) {
            const el = document.getElementById(`${decodeURIComponent(regexp.groups.category)}`);

            if (el) {
              el.classList.remove('!text-black');
              el.classList.add('!text-footer-title');
            }
          }
        },
        setClass(el, category) {
          if (category === el.id) {
            el.classList.remove('!text-black');
            el.classList.add('!text-footer-title');

            return;
          }

          el.classList.add('!text-black');
          el.classList.remove('!text-footer-title');
        },
        toggleNewFilter() {
          this.advancedNewOpen = !this.advancedNewOpen;
        },
        removeFilter(value) {
          this.globalRefine([value]);
        },
        // clickOutside(e) {
        //   const list = [
        //     'category-selector',
        //     'cat-btn',
        //     'cat-svg',
        //     'cat-path',
        //   ];
        //
        //   if (!list.find(i => i === e.target.id)) {
        //     this.openSelector = false;
        //   }
        // },
        clickFilter: debounce(function (items, refine, init = false) {
          // this.openSelector = init ? false : true;

          this.categorySelect = items;

          this.categoryFilter = this.categorySelect.filter(item => item.isRefined);
        }),
        selectCategory: debounce(function (category) {
          if (!category.isRefined) {
            if (this.productType === "new") {
              this.$store.dispatch("analytics/onCategoryClicked", {
                equipmentType: 0,
                categoryTitle: `${category.label} (${this.newCategory})`
              })
            } else {
              this.$store.dispatch("analytics/onCategoryClicked", {
                equipmentType: 1,
                categoryTitle: `${category.label} (${this.industry})`
              })
            }
          }

          this.globalRefine([category.value]);
        }),
        selectIndustry: debounce( async function(industry) {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.delete('menu[industry]');

          //for some reasons it only delete one item, so just run it again
          let repeat = false
          do {
            repeat = false;
            currentUrl.searchParams.forEach((value, key) => {
              if (key.startsWith('refinementList[category]')) {
                currentUrl.searchParams.delete(key);
                repeat = true
              }
            });
          }
          while(repeat)


          // Remove the 'page' parameter
          currentUrl.searchParams.delete('page');

          let url = currentUrl.toString();

          // Update the URL parameter
          if (industry){
            // Check if there are any search parameters left

            let encoded = "menu%5Bindustry%5D=" + encodeURIComponent(decodeURIComponent(`${industry}`))

            if (currentUrl.search) {
              // If search params exist, append with `&`
              url += "&" + encoded
            } else {
              // If no search params exist, append with `?`
              url += "?" + encoded
            }
          }

          await this.$store.dispatch("analytics/onCategoryClicked", {
            equipmentType: this.productType === "new" ? 0 : 1,
            categoryTitle: industry
          })

          window.location.href = url;
        }),

        createData() {
          // 1. Create a render function
          let renderMenu = (renderOptions, isFirstRender) => {
            let { items, refine } = renderOptions;

            this.refineIndustry = (industry) => refine(industry);

            const exceptList = {
              'Hay & Forage': 'Hay',
            };

            const except = Object.keys(exceptList).find(k => k === this.industry);

            if (exceptList[except]) {
              this.refineIndustry(exceptList[except])
            }

            if (
              !items.some((i) => {
                if (i.isRefined) {
                  this.industry = i.value;
                  return true;
                }
                return false;
              })
            ) {
              this.industry = "all"; //isFirstRender?window.industryQuery:
            }
          };

          const renderCategory = (renderOptions) => {
            let {items, refine} = renderOptions;

            if (
              !items.some((i) => {
                if (!i.isRefined) {
                  return false;
                }

                this.newCategory = i.value;

                if (i.value === 'Combines') {
                  this.newCategoryUrl = '/products/new/categories/en_us_combines';
                } else if (i.value === 'Cotton') {
                  this.newCategoryUrl = null;
                } else {
                  this.newCategoryUrl = '/products/new/categories/' + i.value.toString().replace(/\W+/, '').toLowerCase();
                }

                return true;
              })
            ) {
              this.newCategory = null;
            }

            this.refineNewCategory = (category) => {
              return new Promise((resolve) => resolve(refine(category)))
                .then(() => {
                  const elems = document.querySelectorAll('.new-product-el');

                  if (elems) {
                    elems.forEach((el) => this.setClass(el, category));
                  }
                });
            };
          };

          this.search.addWidget(
            instantsearch.widgets.configure({
              filters: this.searchFilters,
              // hitsPerPage: 1000
              hitsPerPage: 20
            })
          );

          let customMenu = instantsearch.connectors.connectMenu(renderMenu);

          this.search.addWidget(
            customMenu({
              attribute: "industry",
            })
          );

          /**
           * Set hidden search query so we can maintain it from the top URL bar
           */
          if (document.getElementById("searchbox")) {
            this.search.addWidget(
              instantsearch.widgets.searchBox({
                container: "#searchbox",
              })
            );
          }

          const gen= document.querySelector('body');

          // if (gen) {
          //   gen.addEventListener('click', (e) => this.clickOutside(e));
          // }

          /**
           * Category filter
           */
          if (document.getElementById("category-select")) {
            const customRefinementList = instantsearch.connectors.connectRefinementList(renderOptions => {

              const {items, refine, widgetParams} = renderOptions;

              this.globalRefine = refine;

              const container = document.querySelector(widgetParams.container);
              const selector = container.querySelector('#category-selector');

              if (selector) {
                // selector.addEventListener('click', () => this.clickFilter(items, refine));

                this.clickFilter(items, refine, true);
              }
            });

            this.search.addWidget(
              customRefinementList({
                container: "#category-select",
                attribute: "category",
                sortBy: ["name:asc"],
                operator: "or",
                limit: 2000,
              })
            );

            if (document.getElementById("sale-filter")) {
              this.search.addWidget(
                instantsearch.widgets.toggleRefinement({
                  container: "#sale-filter",
                  attribute: "is_clearance",
                  on: true,
                  templates: {
                    labelText() {
                      return 'Sale';
                    },
                  },

                  cssClasses: {
                    label: '!flex cursor-pointer flex-row mx-4 space-x-2 justify-start xl:justify-center items-baseline self-start md:self-end'
                  }
                })
              );
            }

            if (document.getElementById("warranty-filter")) {
              this.search.addWidget(
                instantsearch.widgets.toggleRefinement({
                  container: "#warranty-filter",
                  attribute: "is_warranty",
                  on: true,
                  templates: {
                    labelText() {
                      return 'Warranty';
                    },
                  },
                  cssClasses: {
                    label: '!flex cursor-pointer flex-row mr-4 space-x-2 justify-start xl:justify-center items-baseline self-start md:self-end'
                  }
                })
              );
            }

            if (document.getElementById("tech-reviewed-filter")) {
              this.search.addWidget(instantsearch.widgets.toggleRefinement({
                container: "#tech-reviewed-filter",
                attribute: "is_tech_reviewed",
                on: true,
                templates: {
                  labelText: function labelText() {
                    return 'Tech Reviewed';
                  }
                },
                cssClasses: {
                  label: '!flex cursor-pointer flex-row mr-4 space-x-2 justify-start xl:justify-center items-baseline self-start md:self-end'
                }
              }));
            }
          }

          if (document.getElementById("subcategory-select")) {

            let customCategory = instantsearch.connectors.connectMenu(renderCategory);

            this.search.addWidget(
              customCategory({
                attribute: "category",
              })
            );

            const customRefinementList = instantsearch.connectors.connectRefinementList(renderOptions => {

              const {items, refine, widgetParams} = renderOptions;

              const attachment = items.find((i, k) => {
                if (i.value.toString().match(/Attachments.+/)) {
                  i.key = k;

                  return true;
                }

                return false;
              });

              if (attachment) {
                items.splice(attachment.key, 1);

                items.unshift(attachment);
              }

              this.globalRefine = refine;

              const container = document.querySelector(widgetParams.container);
              const selector = container.querySelector('#category-selector');


              if (selector) {
                // selector.addEventListener('click', () => this.clickFilter(items, refine));

                this.clickFilter(items, refine, true);
              }
            });

            this.search.addWidget(
              customRefinementList({
                container: "#subcategory-select",
                attribute: "subcategory",
                sortBy: ["name:asc"],
                operator: "or",
                limit: 2000,
              })
            );
          }

          /**
           * Manufacturer Filter
           */
          if (document.getElementById("manufacturer-select")) {
            this.search.addWidget(
              instantsearch.widgets.menuSelect({
                container: "#manufacturer-select",
                attribute: "manufacturer",
                limit: 2000,
              })
            );
          }

          /**
           * Model Filter
           */
          if (document.getElementById("model-select")) {
            this.search.addWidget(
              instantsearch.widgets.menuSelect({
                container: "#model-select",
                attribute: "model_name",
                limit: 20000,
              })
            );
          }

          /**
           * Years filter
           */
          if (document.getElementById("year-filter")) {
            this.search.addWidget(
              instantsearch.widgets.rangeSlider({
                container: '#year-filter',
                attribute: 'model_year',
                // min: 1890, // Optional: Define min range based on your data
                // max: 2025, // Optional: Define max range based on your data
                step: 1, // Increment step
                templates: {
                  header: 'Filter by Year',
                },
              })
            );
          }

          /**
           * Hours filter
           */
          if (document.getElementById("hour-filter")) {
            let customHoursRangeInput = instantsearch.connectors.connectRange(
              this.renderRangeInputFactory("hours")
            );
            this.search.addWidget(
              customHoursRangeInput({
                container: document.getElementById("hour-filter"),
                attribute: "operation_hours",
              })
            );
          }

          /**
           * Advanced Filter Options
           */
          if (document.getElementById("advanced-option-filters")) {
            let renderOptionsRefinementList = (renderOptions) => {

              let {items, refine, widgetParams} = renderOptions;
              let grouped = {};
              let groupedKeys = [];

              let filterType = widgetParams.attribute
              if (filterType === "options"){
                this.isAdvancedFilterOptions = !!items.length;
                items.forEach((i) => {
                  i.optionLabel = i.label.split("|")[0];
                  i.optionValue = i.label.substring(i.optionLabel.length + 1);
                  if (!Array.isArray(grouped[i.optionLabel])) {
                    grouped[i.optionLabel] = [];
                    groupedKeys.push(i.optionLabel);
                  }
                  grouped[i.optionLabel].push(i);
                });
              } else if (filterType === "location") {
                this.isAdvancedFilterLocation = !!items.length;

                groupedKeys = ["Location"];
                grouped["Location"] = [];

                // ✅ Sort locations alphabetically before processing
                items.sort((a, b) => a.label.localeCompare(b.label));

                items.forEach((i) => {
                  i.optionLabel = i.label//.split("|")[0];
                  i.optionValue = i.label//.substring(i.optionLabel.length + 1);
                  grouped["Location"].push(i)
                });

                const found = grouped["Location"].find(i => i.isRefined);

                if (found) {
                  this.locationName = found.value;
                } else {
                  this.locationName = '';
                }
              }
              else if (filterType === "manufacturer") {
                this.isAdvancedFilterBrand = !!items.length;

                groupedKeys = ["Brand"]
                grouped["Brand"] = []
                items.forEach((i) => {
                  i.optionLabel = i.label//.split("|")[0];
                  i.optionValue = i.label//.substring(i.optionLabel.length + 1);
                  grouped["Brand"].push(i)
                })
              }

              widgetParams.container.querySelectorAll(`.filter.type-${filterType}`).forEach((element) => {
                element.remove(); // Remove all existing filters of the current type
              });

              // Create the new filters and append them to the container
              const newFiltersHTML = groupedKeys
                .map(
                  (groupKey) =>
                    `<div class="filter type-${filterType}">` +
                    `<label>${groupKey}</label>` +
                    grouped[groupKey]
                      .map(
                        (item) =>
                          `<input type="checkbox" data-value="${item.value}"${
                            item.isRefined ? "checked" : ""
                          } class="styled-checkbox">
             <label class="option-refinement" data-value="${
                            item.value
                          }">${item.optionValue} (${item.count})</label>`
                      )
                      .join("") +
                    `</div>`
                )
                .join("");

              // Append the new filters to the container
              widgetParams.container.insertAdjacentHTML("beforeend", newFiltersHTML);

              [
                ...widgetParams.container.querySelectorAll(`.filter.type-${filterType}` + " .option-refinement,input"),
              ].forEach((element) => {
                element.addEventListener("click", (event) => {
                  event.preventDefault();
                  refine(event.currentTarget.dataset.value);
                });
              });
            };

            let customRefinementList =
              instantsearch.connectors.connectRefinementList(
                renderOptionsRefinementList
              );

            // Add a separate widget for City items
            this.search.addWidget(
              customRefinementList({
                container: document.querySelector("#advanced-option-filters"),
                attribute: "location", // Replace with your actual "City" attribute
                operator: "and",
                limit: 30,
              })
            );

            // Add a separate widget for Manufacture items
            this.search.addWidget(
              customRefinementList({
                container: document.querySelector("#advanced-option-filters"),
                attribute: "manufacturer", // Replace with your actual "City" attribute
                operator: "and",
                limit: 30,
              })
            );

            this.search.addWidget(
              customRefinementList({
                container: document.querySelector("#advanced-option-filters"),
                attribute: "options",
                operator: "and",
                limit: 30,
              })
            );
          }

          let baseIndex = this.productType + "_products";

          let items = [{label: "Trending", value: window.addEnvPrefToIndex(baseIndex)}];

          if (this.productType === "used") {
            items.push({
              label: "Lowest Price",
              value: window.addEnvPrefToIndex("used_products_price_asc"),
            });
            items.push({
              label: "Highest Price",
              value: window.addEnvPrefToIndex("used_products_price_desc"),
            });
            items.push({
              label: "Lowest engine hours",
              value: window.addEnvPrefToIndex("used_products_hours_asc"),
            });
            items.push({
              label: "Highest engine hours",
              value: window.addEnvPrefToIndex("used_products_hours_desc"),
            });
            items.push({
              label: "Oldest first",
              value: window.addEnvPrefToIndex("used_products_year_asc"),
            });
            items.push({
              label: "Newest first",
              value: window.addEnvPrefToIndex("used_products_year_desc"),
            });
            items.push({
              label: "Lowest Horse Power",
              value: window.addEnvPrefToIndex("used_products_horse_power_asc"),
            });
            items.push({
              label: "Highest Horse Power",
              value: window.addEnvPrefToIndex("used_products_horse_power_desc"),
            });
            items.push({
              label: "Recently added",
              value: window.addEnvPrefToIndex("used_products_modified_desc"),
            });
          }

          // Desktop Sort By
          if (document.getElementById("products-sort-by")) {
            this.search.addWidget(
              instantsearch.widgets.sortBy({
                container: "#products-sort-by",
                items,
              })
            );
          }
          // Mobile Sort By
          if (document.querySelector(".products-sortby-links")) {
            let mobileSortBy = instantsearch.connectors.connectSortBy(
              (renderOptions, isFirstRender) => {
                let {options, currentRefinement, refine} = renderOptions;
                let list = document.querySelector(".products-sortby-links");
                if (isFirstRender) {
                  items.forEach((item) => {
                    let a = document.createElement("a");
                    a.href = "#";
                    a.innerText = item.label;
                    a.dataset.index = item.value;
                    let li = document.createElement("li");
                    li.appendChild(a);
                    list.appendChild(li);
                    $(a).on("click", (e) => {
                      e.preventDefault();
                      $(window).scrollTop(0);
                      refine(item.value);
                      setTimeout(
                        () => $(".products-search").removeClass("open"),
                        300
                      );
                    });
                  });
                }
                let links = $(list).find("li a");
                links.removeClass("has-text-bold");
                links
                  .filter('[data-index="' + currentRefinement + '"]')
                  .addClass("has-text-bold");
              }
            );

            this.search.addWidget(mobileSortBy({items}));
          }

          /**
           * Algolia Results - "Hits"
           */
          let renderHits = (renderOptions) => {
            let {hits, results} = renderOptions;

            this.hits = hits;
            this.nbHits = results ? results.nbHits : 0;

            // if (hits.length) {
            //   this.download(hits, 'json.txt', 'text/plain');
            // }

            setTimeout(function () {
              // console.log($('.video-loading'))
              $(".video-loading")
                .removeClass("video-loading")
                .addClass("video-loaded");

              // Create Gallery
              $(".gallery").each(function () {
                // the containers for all your galleries
                $(this).magnificPopup({
                  delegate: "a",
                  type: "image",
                  gallery: {enabled: true},
                  callbacks: {
                    elementParse: function (item) {
                      if (item.el.context.className == "video") {
                        (item.type = "iframe"),
                          (item.iframe = {
                            patterns: {
                              youtube: {
                                index: "youtube.com/",
                                id: "v=",
                                src: "//www.youtube.com/embed/%id%?autoplay=1",
                              },
                              vimeo: {
                                index: "vimeo.com/",
                                id: "/",
                                src: "//player.vimeo.com/video/%id%?autoplay=1",
                              },
                            },
                          });
                      } else {
                        item.type = "image";
                      }
                    },
                  },
                });
              });

              $(".magnetic-popup").magnificPopup({
                type: "image",
              });

              $(".magnetic-popup-gallery").magnificPopup({
                delegate: "a",
                type: "image",
                gallery: {enabled: true},
                callbacks: {
                  elementParse: function (item) {
                    if (item.el.context.className == "video") {
                      (item.type = "iframe"),
                        (item.iframe = {
                          patterns: {
                            youtube: {
                              index: "youtube.com/",
                              id: "v=",
                              src: "//www.youtube.com/embed/%id%?autoplay=1",
                            },
                            vimeo: {
                              index: "vimeo.com/",
                              id: "/",
                              src: "//player.vimeo.com/video/%id%?autoplay=1",
                            },
                          },
                        });
                    } else {
                      item.type = "image";
                    }
                  },
                },
              });
            }, 100);
          };

          let customHits = instantsearch.connectors.connectHits(renderHits);

          this.search.addWidget(
            customHits({
              container: "#hits",
            })
          );

          // Pagination
          if ($("#pagination").length > 0) {
            this.search.addWidget(
              instantsearch.widgets.pagination({
                container: "#pagination",
                cssClasses: {
                  list: ["pagination"],
                },
              })
            );
          }

          //Promotions Filter
          if ($("#promotions_box")) {
            const renderPromoRefinement = (renderOptions, isFirstRender) => {
              const {value, refine, widgetParams} = renderOptions;

              if (isFirstRender) {
                const label = document.createElement("label");
                label.htmlFor = "has_promo";

                const input = document.createElement("input");
                input.type = "checkbox";
                input.id = "has_promo";
                input.classList.add("styled-checkbox");

                input.addEventListener("change", (event) => {
                  refine({isRefined: !event.target.checked});
                });

                label.appendChild(document.createTextNode("Promotion"));

                widgetParams.container.appendChild(input);
                widgetParams.container.appendChild(label);
              }

              widgetParams.container.querySelector("input").checked =
                value.isRefined;
            };

            const customToggleRefinement =
              instantsearch.connectors.connectToggleRefinement(
                renderPromoRefinement
              );

            Array.from(document.querySelectorAll(".promotions-box")).forEach(
              (widget) => {
                this.search.addWidget(
                  customToggleRefinement({
                    container: widget,
                    attribute: "has_promo",
                  })
                );
              }
            );
          }

          // Clearance Filter
          if ($("#clearance_box")) {
            const renderClearanceRefinement = (
              renderOptions,
              isFirstRender
            ) => {
              const {value, refine, widgetParams} = renderOptions;

              if (isFirstRender) {
                const label = document.createElement("label");
                label.htmlFor = "has_clearance";

                const input = document.createElement("input");
                input.type = "checkbox";
                input.id = "has_clearance";
                input.classList.add("styled-checkbox");

                input.addEventListener("change", (event) => {
                  refine({isRefined: !event.target.checked});
                });

                label.appendChild(document.createTextNode("Sale"));

                widgetParams.container.appendChild(input);
                widgetParams.container.appendChild(label);
              }

              widgetParams.container.querySelector("input").checked =
                value.isRefined;
            };

            const customToggleRefinement =
              instantsearch.connectors.connectToggleRefinement(
                renderClearanceRefinement
              );

            Array.from(document.querySelectorAll(".clearance-box")).forEach(
              (widget) => {
                this.search.addWidget(
                  customToggleRefinement({
                    container: widget,
                    attribute: "is_clearance",
                  })
                );
              }
            );
          }

          this.search.start();

          // url query industry to search for if available
          // Filter by industry if it is not null
          if (this.industry !== "all") {
            this.refineIndustry(this.industry);
          }

          // Default url?query= param to search for
          let query = window.location.search;

          if (query !== "") {
            query = query
              .substring(1)
              .split("&")
              .map((kv) => kv.split("="))
              .find((q) => q[0].toLowerCase() === "query");
            if (query && query.length > 1) {
              query = query[1];
            } else {
              query = "";
            }
          }

          if (query !== "") {
            query = query.split("+").join(" ");
            this.search.helper.setQuery(query);
            this.search.helper.search();
          }

          this.search.on("render", () => {
            const input = document.querySelector("#tech-reviewed-filter input[type='checkbox']");
            if (input) {
              this.isTech = input.checked;
            }
          });

          this.search.on("render", () => {
            if (this.loading) {
              this.loading = false;
              this.$nextTick(() => {
                this.filtersOnly = !this.$refs.hits;
                if (
                  window.history.state &&
                  window.history.state.scrollTop &&
                  window.history.state.scrollTop !== null
                ) {
                  setTimeout(() => {
                    $(window).scrollTop(window.history.state.scrollTop);
                    window.history.replaceState(
                      null,
                      document.title,
                      document.location.href
                    );
                  }, 200);
                }
              });
            }
          });
        },

        // Refine by industry
        industryRefinement(industry, event) {
          if (this.filtersOnly) return true; // allow the link to work
          if (typeof event !== "undefined") {
            event.preventDefault();
          }

          this.resetSearchFilters();
          this.industry = industry;
          if (industry !== "all") {
            this.refineIndustry(industry);
          }
          this.search.helper.setQuery("");
          $(".products-search").removeClass("open");
          $('#department-filter').hide('slow');

          $("body,html").animate({
            scrollTop: 0,
          });
        },

        getQuoteRequest(item) {
          this.quoteRequest = item;
        },

        // Toggle advanced filter dropdown
        toggleAdvancedFilters() {
          this.showAdvancedFilters = !this.showAdvancedFilters
          $(this.$refs.advancedFilterToggle).toggleClass("open");
        },

        // Toggle details in CTA
        toggleDetails(event) {
          let detailElem = event.target.parentElement;
          detailElem.classList.toggle("open");
        },

        // Search
        refineSearch() {
          if (this.filters.year) this.filters.year();
          if (this.filters.hours) this.filters.hours();
          this.search.helper.search();
          setTimeout(() => {
            $("img[data-loaded=true]").attr({"data-loaded": false});
          }, 200);
        },

        submitSearch() {
          if (this.filtersOnly) {
            window.location =
              "/" +
              this.productType +
              "-products" +
              (location.search ? location.search + "&" : "?") +
              "_show_";
          } else {
            this.refineSearch();
            this.closeSearch();
            $("body,html").animate({
              scrollTop: 0,
            });
          }
        },
        clickNewCategory(e) {
          this.search.helper.clearRefinements();
          this.search.helper.setQuery("");
          // this.search.helper.search();

          this.refineNewCategory(e.target.id);
          this.detectedPage(e.target.id)

          this.$store.dispatch("analytics/onCategoryClicked", {
            equipmentType: 0,
            categoryTitle: e.target.id
          })
        },

        // Reset serach filter
        resetSearchFilters() {
          this.industry = "all";
          this.search.helper.clearRefinements();
          this.search.helper.setQuery("");
          this.search.helper.search();
        },

        // Render input ranges
        renderRangeInputFactory(input) {
          return (renderOptions, isFirstRender) => {
            // Rendering logic
            // Create the render function
            let {start, range, refine, widgetParams} = renderOptions;
            let [min, max] = start;

            if (isFirstRender) {
              let form = document.createElement("form");
              let filterFunction = (event) => {
                if (event.preventDefault) event.preventDefault();

                let rawMinInputValue = parseFloat(
                  event.target.elements.min.value
                );
                let rawMaxInputValue = parseFloat(
                  event.target.elements.max.value
                );
                let refinement = [
                  Number.isFinite(rawMinInputValue)
                    ? rawMinInputValue
                    : undefined,
                  Number.isFinite(rawMaxInputValue)
                    ? rawMaxInputValue
                    : undefined,
                ];
                refine(refinement);
              };
              form.addEventListener("submit", filterFunction);
              this.filters[input] = () => filterFunction({target: form});
              widgetParams.container.appendChild(form);

              return;
            }
            widgetParams.container.querySelector("form").innerHTML = `
                        <input type="submit" hidden />
                        <input
                          type="number"
                          name="min"
                          placeholder="${range.min}"
                          value="${Number.isFinite(min) ? min : ""}"
                        />
                        <input
                          type="number"
                          name="max"
                          placeholder="${range.max}"
                          value="${Number.isFinite(max) ? max : ""}"
                        />
                      `;
          };
        },

        toggleView(event) {
          let type = event.target.value;
          this.viewType = type;
        },

        onResize() {
          if (window.outerWidth <= 799) {
            this.viewType = "grid-view";
          }
        },

        /**
         * Close search
         */
        closeSearch() {
          $(".products-search").removeClass("open");
        },

        /**
         * Save the current search to the Customer's account
         */
        async saveSearch(e) {
          e.preventDefault();

          let form = $(e.currentTarget);
          let path = window.location.pathname + window.location.search;
          let _this = this;
          form.find(".form-spinner").css("left", "50%");
          form.find(".submit-label").hide();

          const data = {
            url: path
          };

          const analyticsData = {
            equipmentType: _this.productType === 'new' ? 0 : 1
          }

          const onSuccess = function(response) {
            form.find(".form-spinner").css("left", "-1000%");
            form.find(".submit-label").show().text("SAVED!");
            setTimeout(() => {
              form.find(".submit-label").text("SAVE SEARCH");
            }, 2000);

            try{
              _this.$store.dispatch('analytics/onSaveSearch', analyticsData)
            } catch (e) {
              console.error("Event was not sent to MD", e)
            }

            notificationController.successMessage("Saved!")
          }

          try {
            await axios.post(apiUrls.productSearchSave, data)
            onSuccess();
          } catch (e) {
            if (e.response && e.response.status === 401) {
              if (window.openLogin){

                window.openLogin(createSaveSearchParams(data, function() {
                  onSuccess()
                }, analyticsData))

              } else {
                console.error("openLogin is not active yet")
              }
            } else {
              // Handle other errors (show error message or log the error)
              console.error("Error saving product:", e.response ? e.response.data : e.message);
              alert("An error occurred while smaking the request. Please try again.");
            }
          }
        },

        redirectToLogin() {
          window.location = window.location.origin + "/customer/login";
        },

        trend(e) {
          let url = $(e.target).closest("a").attr("href");
          $.post(url);
        },
      }, // methods
    }); // Vue
  } // startApp()

  /**
   * Close the product search bar to reveal the primary nav
   */
  backToNav(e) {
    e.preventDefault();
    $(".products-search").addClass("close");
  }

  /**
   * Show the product filter
   * @param e
   */
  openFilter(e) {
    e.preventDefault();
    $(".products-search").removeClass("close");
  }

  showFilter(filter) {
    if (
      (!$(".products-search").hasClass("open") && this.isActive(filter)) ||
      !this.isActive(filter)
    ) {
      $(".products-search").addClass("open");
    } else if (this.isActive(filter)) {
      $(".products-search").removeClass("open");

      this.active_mobile_filter = "";
    }
    $(".products-sortby,.products-category-nav,.products-filters").hide();
    let selectorMap = {
      department: ".products-category-nav",
      filter: ".products-filters",
      sort: ".products-sortby",
    };
    $(selectorMap[filter]).show();

    this.active_mobile_filter = filter;
  }

  showDepartments() {
    const el = $('#department-filter');

    if (el.css('display') === 'block') {
      this.active_mobile_filter = '';

      return el.hide('slow');
    }

    el.show('slow');

    this.active_mobile_filter = 'department';
  }

  showNewFilter() {
    const el = $('.products-filters');
    const depart = $('#department-filter');

    if (depart.css('display') === 'block') {
      depart.hide('fast');
    }

    if (el.css('display') === 'block') {
      this.active_mobile_filter = '';

      return el.hide('slow');
    }

    el.show('slow');

    this.active_mobile_filter = 'filter';
  }

  /**
   * Is Active.
   *
   * Checks for an active mobile filtet tab.
   *
   * @param type
   *
   * @returns {boolean}
   */
  isActive(type) {
    return this.active_mobile_filter === type;
  }
}

$(document).on("ready", () => {
  window.ProductsSearch = new ProductsSearch();
});



// WEBPACK FOOTER //
// ./resources/js/ProductSearch.js